var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-jin-nang-table',{attrs:{"titleList":_vm.titleList,"dataList":_vm.dataList},on:{"row-clicked":_vm.repoClick,"titleSort":_vm.titleSort}})}
var staticRenderFns = []

export { render, staticRenderFns }